(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evento-curso"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('evento-form')) {
    class EventoForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.list = this.querySelector('[data-attendees]');
        this.qtyInput = this.querySelector('[data-qty]');
        this.totalEl = this.querySelector('[data-total]');
        this.errorEl = this.querySelector('[data-error]');
        this.button = this.querySelector('[data-submit]');
        this.maxOrder = parseInt(this.dataset.maxOrder, 10) || 5;
        this.money = new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
        });

        this.form.addEventListener('change', (event) => {
          if (event.target.name === 'variant') this.setQty(this.qty());
        });
        this.querySelectorAll('[data-step]').forEach((btn) => {
          btn.addEventListener('click', () => this.setQty(this.qty() + parseInt(btn.dataset.step, 10)));
        });
        this.qtyInput.addEventListener('change', () => this.setQty(this.qty()));
        this.form.addEventListener('submit', (event) => this.onSubmit(event));

        // Si el cliente vuelve atrás desde el checkout, reactivamos el botón
        window.addEventListener('pageshow', () => this.setLoading(false));

        this.setQty(1);
      }

      selected() {
        return this.form.querySelector('input[name="variant"]:checked');
      }

      qty() {
        return parseInt(this.qtyInput.value, 10) || 1;
      }

      maxQty() {
        const variant = this.selected();
        if (!variant) return 1;
        const stock = parseInt(variant.dataset.stock, 10);
        const limit = Number.isNaN(stock) ? this.maxOrder : Math.min(this.maxOrder, stock);
        return Math.max(1, limit);
      }

      setQty(value) {
        const max = this.maxQty();
        const qty = Math.max(1, Math.min(max, value));
        this.qtyInput.value = qty;
        this.qtyInput.max = max;
        this.renderAttendees(qty);
        this.updateTotal();
      }

      updateTotal() {
        const variant = this.selected();
        if (!variant || !this.totalEl) return;
        const cents = parseInt(variant.dataset.price, 10) * this.qty();
        this.totalEl.textContent = this.money.format(cents / 100);
      }

      renderAttendees(count) {
        const template = this.querySelector('template[data-attendee-template]');
        let blocks = this.list.querySelectorAll('[data-attendee]');

        for (let i = blocks.length; i < count; i++) {
          const node = template.content.firstElementChild.cloneNode(true);
          node.querySelector('[data-index]').textContent = i + 1;
          node.querySelectorAll('input[data-field]').forEach((input) => {
            const id = `ev-${this.dataset.section}-${input.dataset.field}-${i}`;
            input.id = id;
            const label = node.querySelector(`label[data-for="${input.dataset.field}"]`);
            if (label) label.htmlFor = id;
          });
          if (i === 0) node.querySelector('[data-buyer-note]').hidden = false;
          this.list.appendChild(node);
        }

        blocks = this.list.querySelectorAll('[data-attendee]');
        for (let i = blocks.length - 1; i >= count; i--) blocks[i].remove();
      }

      showError(message) {
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }

      setLoading(isLoading) {
        if (!this.button) return;
        this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.button.querySelector('[data-label]').hidden = isLoading;
        this.button.querySelector('[data-loading]').hidden = !isLoading;
      }

      async onSubmit(event) {
        event.preventDefault();
        this.showError('');

        if (!this.form.reportValidity()) return;

        const variant = this.selected();
        if (!variant) {
          this.showError('Elige un tipo de entrada para continuar.');
          return;
        }

        const blocks = [...this.list.querySelectorAll('[data-attendee]')];
        const total = blocks.length;
        const value = (block, field) => block.querySelector(`[data-field="${field}"]`).value.trim();

        // Una línea por asistente, así cada entrada queda con su nombre en el pedido
        const items = blocks.map((block, index) => ({
          id: parseInt(variant.value, 10),
          quantity: 1,
          properties: {
            Asistente: value(block, 'nombre'),
            Email: value(block, 'email'),
            'Teléfono': value(block, 'telefono'),
            Entrada: `${index + 1} de ${total}`,
          },
        }));

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

        this.setLoading(true);

        try {
          if (this.dataset.clearCart === 'true') {
            await fetch(`${root}cart/clear.js`, { method: 'POST', headers });
          }

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers,
            body: JSON.stringify({ items }),
          });
          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description || data.message || 'No se ha podido reservar la entrada. Inténtalo de nuevo.'
            );
          }

          window.location.href = `${root}checkout`;
        } catch (error) {
          this.showError(error.message);
          this.setLoading(false);
        }
      }
    }

    customElements.define('evento-form', EventoForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
